<template>
  <div class="callout">
    <p class="callout__text">Você precisa levar o pedido médico original no dia do atendimento.</p>
    <button class="callout__link" type="button" @click="$emit('explain-click')">
      Por que preciso levar se já enviei aqui?
    </button>
  </div>
</template>

<script>
export default {
  name: 'CalloutMessage',
};
</script>

<style scoped>
.callout {
  background-color: #fef1e6;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  word-break: break-word;
  overflow-wrap: break-word;
  margin-bottom: 8px;
  align-items: flex-start;
}

.callout__text {
  font-weight: 599;
  font-size: 1rem;
  line-height: 1.5;
  color: #000000;
  margin: 0;
  text-align: left;
}

.callout__link {
  font-weight: 599;
  font-size: 0.875rem;
  line-height: 1.2;
  color: #0037ff;
  text-align: left;
  word-break: break-word;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}
</style>
